<section class="sh-dialog__content">
    <ng-container *ngIf="thesaurusConcept">
        <h4 class="sh-clear-margin-top">{{ "thesaurus.thesaurus-concept-dialog.translations" | translate }}</h4>
        <dl class="sh-description-list">
            <ng-container *ngFor="let preferredLabel of preferredLabels">
                <dt class="sh-description-list__term">{{ preferredLabel.Lang | titlecase }}</dt>
                <dd class="sh-description-list__details sh-preserve-linebreaks sh-wrap-text">{{ preferredLabel.Label }}</dd>
            </ng-container>
        </dl>
        <h4>{{ "thesaurus.thesaurus-concept-dialog.alternative-terms" | translate }}</h4>
        <dl class="sh-description-list">
            <ng-container *ngIf="alternativeLabels.length === 0">
                <p>-</p>
            </ng-container>
            <ng-container *ngFor="let langLabels of alternativeLabels">
                <dt class="sh-description-list__term">{{ langLabels.Lang | titlecase }}</dt>
                <dd class="sh-description-list__details sh-preserve-linebreaks sh-wrap-text">
                    <ng-container *ngFor="let label of langLabels.Labels">{{ label }}<br /> </ng-container>
                </dd>
            </ng-container>
        </dl>
    </ng-container>
</section>
